export let searchBoxText = "YDACue";
export let noResultsTitle = "B8y2D";
export let noResultsMessage = "WtFTFc";
export default {searchBoxText,noResultsTitle,noResultsMessage};